
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form} from "reactstrap";
import ReviewCompanyService from "../../../../services/reviewCompanyService";
import CompanyForm from "./Form";
import {companyType} from "../../../../util/companyType";
import _ from "lodash";
import ReviewCompanyForm from "./Form";

class ReviewCompanyCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {}
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCompanyTypeChange = this.handleCompanyTypeChange.bind(this);
        this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleCompanyTypeChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({companyTypeList: []});
        } else {
            this.setState({companyTypeList: valueObj});
            const keys = _.map(valueObj, "key")
            this.setState({companyTypeList: keys});
        }
    };

    handleCountrySelectChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        ReviewCompanyService.create(this.state).then(response => {
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/user/company/list");
            } else {
                this.setState({errorData: response.data});
            }
        });
    }

    render() {
        return (
            <>
                <SimpleHeader
                    name="Create"
                    parentName="Company"
                    heading="XareGrowth"
                    newBtnUrl="/user/company/list"
                    newBtnText="List Companies"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Create Company</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ReviewCompanyForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={false}
                                    selectedCountry = {this.state.selectedCountry}
                                    companyType = {companyType}
                                    onCompanyTypeChange={this.handleCompanyTypeChange}
                                    handleCountrySelectChange={this.handleCountrySelectChange}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ReviewCompanyCreate;
